import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Tooltip, Alert } from 'reactstrap';
import { GlobalContext } from '../../context/GlobalContext';

export const Header = ({title}) => {

    //GET GLOBAL CONTEXT
    const context = useContext(GlobalContext);
    const { darkTheme, toggleTheme, isMobile } = context;

    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggle = () => setTooltipOpen(!tooltipOpen);
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let isMobile2 = (/windows phone/i.test(userAgent)) && (/android/i.test(userAgent)) && (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream);
    
    useEffect(() => {
        if (darkTheme) {
            document.body.classList.add("bg-dark-primary");
            document.getElementById('root').classList.add('bg-dark-primary');
        } else {
            document.body.classList.remove("bg-dark-primary");
            document.getElementById('root').classList.remove('bg-dark-primary');
        }
    }, [darkTheme]);

    const handleLogoClick = () => {
        if (!isMobile2) {
            window.location.href = `${process.env.REACT_APP_MIPORTAL_URL}`;
        }

    };

    const handleChange = (e) => {
        const checked = e.target.checked;
        toggleTheme(checked);
    };

    const redirectToKardex = () => {
        if (!isMobile2) {
            window.open(`${process.env.REACT_APP_KARDEX_URL}`);
        }
        
    }

    const handleLogout = () => {
        if (!isMobile2) {
            const form = document.createElement('form');
            form.method = 'post';
            form.action = window.location.origin + '/auth/slologout';
            document.body.append(form);
            form.submit();
        }
        
    };



function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }


    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "Windows";
}

//alert(getMobileOperatingSystem());


if ((/windows phone/i.test(userAgent)) && (/android/i.test(userAgent)) && (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)){
   // console.log((/windows phone/i.test(userAgent.includes("Windows Phone"))) && (/android/i.test(userAgent.includes("Android"))) && (/iPad|iPhone|iPod/.test(userAgent.includes("iPhone")) && !window.MSStream));
 }






    return (
        <>
            <div className="header-app">
                <Row className="ms-3 pt-3">
                    <Col lg="12">
                        <img onClick={handleLogoClick} src="/Images/logo.png" id="logo_miportal" alt="Logo" className="img-header" />
                        <Tooltip placement="bottom" fade={false} isOpen={tooltipOpen} target="logo_miportal" toggle={toggle}>
                            Ir a Miportal
                        </Tooltip>
                        <div className="custom-control-container">
                    
                        {(getMobileOperatingSystem()) == "Windows"  ? (
                                <div style={{ marginRight: '20px' }}>
                                    <span className="logout-button" onClick={handleLogout}>
                                        <i className="bi bi-box-arrow-right"></i>
                                        Cerrar sesión
                                    </span>
                                </div>
                            ) : (
                                <div></div>)}
                            <div className="form-check form-switch">
                                <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={darkTheme} onChange={handleChange} />
                                <label className="text-dark form-check-label" htmlFor="flexSwitchCheckDefault">Modo nocturno</label>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div id="nav-bar-container" className={(darkTheme) ? "bg-dark-primary" : ""}>
                <Container id="nav-bar">
                    <div className="margin-primary">
                        <span>{title}</span>
                        {(getMobileOperatingSystem()) == "Windows"  ? (
                              <span className='kardex-span' onClick={redirectToKardex}>Ver mi kárdex</span>
                        ) : (
                            <div></div>)}
                    </div>
                </Container>
            </div>
            <form id="logout-form" action="/auth/logout" method="post">
          
            </form>
        </>
    )
}
